import { useEffect, useState } from "react";

const KEY = "traide-theme";
if (typeof window !== "undefined" && localStorage.getItem(KEY) === "dark") document.documentElement.classList.add("dark");

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || "light");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(KEY, theme);
  }, [theme]);
  return { theme, dark: theme === "dark", toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")) };
}

export function useLocalFlag(key, initial) {
  const [v, setV] = useState(() => { const s = localStorage.getItem(key); return s == null ? initial : s === "1"; });
  useEffect(() => { localStorage.setItem(key, v ? "1" : "0"); }, [key, v]);
  return [v, setV];
}

export function useMediaQuery(query) {
  const [m, setM] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setM(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return m;
}
